import "/tmp/tmp-3957-e74CiZb5eDpe/190c51fa91a10/index.module.css";
export default {"sider":"index-module__sider___2-j8e"};